export default class Locale_ThemeArea {
	ThemeDeleted: string = "Theme deleted!";
	FailedDeletingTheme: string = "Failed deleting theme!";
	ThemeSaved: string = "Theme saved!";
	FailedSavingTheme: string = "Failed saving theme!";
	ThemeDesigner: string = "Theme Designer";
}